export enum RoomStatus {
	DRAFT = "DRAFT",
	READY = "READY",
	INCART = "INCART",
	ORDERED = "ORDERED",
	INTRASH = "INTRASH",
	PROCESSING = "PROCESSING"
}